module.exports = __webpack_public_path__ + "static/Q6Answer6_Peoplestepontoes_brina_blum-d234c9b9e87ef64e56c4d3a9dd0a4169.jpg";